/* Bedrock — Vidéo produit : le lecteur YouTube ne se charge qu'au clic sur la vignette */
if (!customElements.get('bdr-product-video')) {
  class BdrProductVideo extends HTMLElement {
    connectedCallback() {
      this.querySelector('button').addEventListener('click', () => {
        const i = document.createElement('iframe');
        i.src = this.dataset.embedSrc;
        i.title = this.dataset.title;
        i.allow = 'autoplay; encrypted-media; picture-in-picture';
        i.allowFullscreen = true;
        this.replaceChildren(i);
      }, { once: true });
    }
  }
  customElements.define('bdr-product-video', BdrProductVideo);
}
